import Context from 'widget/contexts/Player/PlayerContext';
import Provider from 'widget/contexts/Player/PlayerProvider';

export default {
  Consumer: Context.Consumer,
  Context,
  Provider,
};
